import { applyPrecision } from '@orionprotocol/utils';

 
import { useAssetToAddress, usePricesWithQuoteAsset } from '../api';

export const useORNPrice = (): string | undefined => {
  const assetToAddress = useAssetToAddress();
  const pricesWithQuoteAsset = usePricesWithQuoteAsset();

  const ornAddress = assetToAddress?.ORN;

  if (assetToAddress === undefined || ornAddress === undefined) return;

  const ornPrice = pricesWithQuoteAsset?.prices[ornAddress];
  if (ornPrice === undefined) return;

  return applyPrecision(ornPrice, 2);
};
